export default __webpack_public_path__ + "static/media/menu.bb4dc25c.svg";